import Axios from 'axios'
import * as React from 'react'
import { render } from 'react-dom'

import { applyInterceptors } from './api/interceptor'
import { Config } from './config'
import BrowserErrorReporter from './Global/BrowserErrors'
import { Segment } from './Global/Segment'
import Routes from './Routes'
import { initializeStore } from './store'

const initialize = async () => {
  applyInterceptors()
  const store = await initializeStore()

  void import('./Global/Segment').then((res) => {
    Segment.initialize(Config.getSegmentWriteKey(), store.getState)
  })

  void import('./Global/Analytics').then(({ Analytics }) => {
    Analytics.initialize(window.GTM_CONTAINER_ID, store.getState)
    window.Analytics = Analytics
  })

  void import('./components/common/ABTestHelper').then(({ ABTestHelper }) => {
    ABTestHelper.initialize()
  })

  void import('./Global/AnalyticsEvents').then(({ Events, Modifiers }) => {
    window.Events = Events
    window.Modifiers = Modifiers
  })

  // Send browser errors to AWS CloudFront
  window.addEventListener('error', BrowserErrorReporter)

  render(<Routes store={store} brand="zervant" />, document.querySelector('#root'))
}

initialize()
